module.exports = __webpack_public_path__ + "static/media/taffiethule13.a4e0045e.jpg";